/**
 * 统一声明一个函数，
 * App可调这方法，传函数名执行相当于代码，
 * 再通过window异步通知App
 *
 * appBridge('函数名')
 * 封装统一一个方法给App，
 * 比如App想获取 getMicQueueList 就 appBridge('getMicQueueList')。
 * 返回给App 是 JSON.stringify(message) ，message 格式是 {type: '函数名',data: 数据}
 * 然后App统一处理
 * **/
export default defineNuxtPlugin(() => {
  //#region appBridge 客户端调用web端方法封装
  const rnFun: any = {
    getNative: 'native'
  }
  // 提前声明方法提供给App调取模块
  // 提前声明函数名，有函数命才可以调取
  const appBridgeFunNames = {
    socketMessage: 'socketMessage', // socket Message
    exitChatRoom: 'exitChatRoom', // AppSocket退出房间
    sendGetTime: 'sendGetTime', // 获取房间计时
    openGift: 'openGift', // 在房间打开礼物弹窗
    openTool: 'openTool', // 打开房间工具栏（App在游戏会用到）
    keepRoom: 'keepRoom', // 最小退出 {isKeepRoom: true/最小化开启，false最小化关闭}
    insufficientBalance: 'insufficientBalance', // 余额不足
    openSharePopup: 'openSharePopup' // 打开分享弹窗
  }
  const appGetMessageFun = {
    sendGetTime: 'sendGetTime'
  }
  /**
   * 安卓和IOS可以直接调这个方法获取数据
   * @param {string} funName 函数名
   * @param {object} data 需要传递的数据
   */
  function appBridge(funName: string, data: { [key in string]: any } | string) {
    const version = common.checkVersion()
    console.log(
      'appBridge => ',
      version.app && !appBridgeFunNames[funName],
      funName,
      data
    )
    // 校验环境 && 没有函数名 就return
    if (version.app && !appBridgeFunNames[funName]) return

    // 过滤data
    const filterData: { [key in string]: any } = AppNative.isJSONStr(data)
      ? JSON.parse(data as string)
      : data

    const roomStore = useRoomStore()
    const callStore = useCallStore()
    const agoraStore = useAgoraStore()
    const trtcStore = useTrtcStore()
    const socketStore = useSocketStore()
    const audioStore = useAudioStore()
    const rechargeStore = useRechargeStore()

    // 设置数据，最后会转成JSONString
    const message = {
      type: funName, // 函数名
      data: null as any // 数据
    }
    switch (funName) {
      // socket回调的消息
      case appBridgeFunNames.socketMessage:
        // 心跳路由不console.log
        if (filterData.route !== 'heartbeat') {
          console.log('appBridge => socketMessage', filterData)
        }
        socketStore.onMsg(
          typeof filterData === 'string' ? JSON.parse(filterData) : filterData
        )
        break
      // AppSocket退出房间
      case appBridgeFunNames.exitChatRoom:
        console.log('appBridge => exitChatRoom', filterData)
        // 退出房间重置SDK数据
        if (roomStore.rtcInfo.rtcType === 'AGORA') {
          agoraStore.leave()
        } else {
          trtcStore.exit()
        }
        break
      // App获取房间计时
      case appBridgeFunNames.sendGetTime:
        message.data = callStore.callTime
        break
      // 在房间打开礼物弹窗
      case appBridgeFunNames.openGift:
        AppNative.appFun(
          AppNative.iosNeedMessageFun.giftPopup,
          JSON.stringify({
            list: [...audioStore.inMicQueueList],
            active: null
          })
        )
        break
      // 打开房间工具栏（App在游戏会用到）
      case appBridgeFunNames.openTool:
        emitter.emit('openToolsPopup')
        break
      // app最小化退出房间
      case appBridgeFunNames.keepRoom:
        roomStore.setQuitRoomType(filterData.isKeepRoom ? 2 : 0)
        break
      // 余额不足提示
      case appBridgeFunNames.insufficientBalance:
        rechargeStore.getAppFirstChargeInfo()
        break
      // 打开分享弹窗
      case appBridgeFunNames.openSharePopup:
        emitter.emit('openSharePopup')
        break
    }

    // 判断是否需要回调给App
    if (appGetMessageFun[funName]) {
      if (version.ios) {
        let appObj: any = {}
        if (window['webkit'].messageHandlers[funName]) {
          appObj = window['webkit'].messageHandlers
        } else {
          appObj = window['ReactNativeWebView']
        }
        // eslint-disable-next-line no-prototype-builtins
        if (appObj.hasOwnProperty('postMessage')) {
          appObj.postMessage(JSON.stringify(message.data))
        } else {
          if (rnFun[funName]) {
            return
          }
          appObj[funName] &&
            appObj[funName].postMessage(JSON.stringify(message.data))
        }
      } else {
        // Android 调用方式
        const appObj = window['androidJsObj']
        appObj[funName](JSON.stringify(message.data))
      }
    }
  }
  window['appBridge'] = appBridge
  //#endregion

  //#region web方法具体处理
  //#endregion
})
